var React = require('react');

function EmailDark (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("path",{"d":"M0 0h32v32H0z","key":0}),React.createElement("path",{"fill":"#505769","d":"M29.33 9.297l.003.036v12A2.67 2.67 0 0 1 26.667 24H5.333a2.67 2.67 0 0 1-2.666-2.667v-12c0-.01.004-.022.004-.034l12.626 7.836a1.332 1.332 0 0 0 1.405-.001L29.33 9.296zm-2.663-2.629c.469 0 .902.133 1.286.347L16 14.432 4.047 7.015a2.632 2.632 0 0 1 1.286-.347z","key":1})]));
}

EmailDark.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32"};

module.exports = EmailDark;

EmailDark.default = EmailDark;
